import { o, c as t, a as e } from "./core.0767a1be.js";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ e("g", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ e("path", {
    d: "M3 17.3V21h3.7",
    "data-name": "Right"
  }),
  /* @__PURE__ */ e("path", { d: "m10 14-6.2 6.2M14 10l6.2-6.2" }),
  /* @__PURE__ */ e("path", {
    d: "M21 6.7V3h-3.7",
    "data-name": "Right"
  })
], -1), a = [
  r
];
function s(c, d) {
  return o(), t("svg", n, a);
}
const i = { render: s };
export {
  i as default,
  s as render
};
//# sourceMappingURL=collapse-unexpanded.f930b5bd.js.map
